import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * Tab Portal component to render tabs.
 * @param {object} props The component props.
 * @param {object} props.children The children to render.
 * @returns {null|JSX.Element} The rendered TabPortal component.
 */
const TabPortal = ({ children }) => {
  const tabRoot = document.getElementById('tabPortal');
  if (tabRoot) {
    return ReactDOM.createPortal(children, tabRoot);
  }
  return null;
};

TabPortal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TabPortal;
